var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixLoyaltyV1Account from '@wix/ambassador-loyalty-v1-account/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var UpdateTrigger;
(function (UpdateTrigger) {
    UpdateTrigger["UNDEFINED"] = "UNDEFINED";
    /** Reward was updated. */
    UpdateTrigger["REWARD_UPDATED"] = "REWARD_UPDATED";
    /** Balance was updated. */
    UpdateTrigger["BALANCE_UPDATED"] = "BALANCE_UPDATED";
    /** Tiers were recalculated. */
    UpdateTrigger["TIERS_RECALCULATED"] = "TIERS_RECALCULATED";
})(UpdateTrigger || (UpdateTrigger = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var SortType;
(function (SortType) {
    /** Should sort by number of matches */
    SortType["COUNT"] = "COUNT";
    /** Should sort by value of the field alphabetically */
    SortType["VALUE"] = "VALUE";
})(SortType || (SortType = {}));
export var SortDirection;
(function (SortDirection) {
    /** Should sort in descending order */
    SortDirection["DESC"] = "DESC";
    /** Should sort in ascending order */
    SortDirection["ASC"] = "ASC";
})(SortDirection || (SortDirection = {}));
export var MissingValues;
(function (MissingValues) {
    /** Should missing values be excluded from the aggregation results */
    MissingValues["EXCLUDE"] = "EXCLUDE";
    /** Should missing values be included in the aggregation results */
    MissingValues["INCLUDE"] = "INCLUDE";
})(MissingValues || (MissingValues = {}));
export var ScalarType;
(function (ScalarType) {
    ScalarType["UNKNOWN_SCALAR_TYPE"] = "UNKNOWN_SCALAR_TYPE";
    /** Count of distinct values */
    ScalarType["COUNT_DISTINCT"] = "COUNT_DISTINCT";
    /** Minimum value */
    ScalarType["MIN"] = "MIN";
    /** Maximum value */
    ScalarType["MAX"] = "MAX";
    /** Sum of values */
    ScalarType["SUM"] = "SUM";
    /** Average of values */
    ScalarType["AVG"] = "AVG";
})(ScalarType || (ScalarType = {}));
export var NestedAggregationType;
(function (NestedAggregationType) {
    NestedAggregationType["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
    /** An aggregation where result buckets are dynamically built - one per unique value */
    NestedAggregationType["VALUE"] = "VALUE";
    /** An aggregation, where user can define set of ranges - each representing a bucket */
    NestedAggregationType["RANGE"] = "RANGE";
    /** A single-value metric aggregation - e.g. min, max, sum, avg */
    NestedAggregationType["SCALAR"] = "SCALAR";
    /** An aggregation, where result buckets are dynamically built - one per time interval (hour, day, week, etc.) */
    NestedAggregationType["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
})(NestedAggregationType || (NestedAggregationType = {}));
export var DateHistogramAggregationInterval;
(function (DateHistogramAggregationInterval) {
    DateHistogramAggregationInterval["UNKNOWN_INTERVAL"] = "UNKNOWN_INTERVAL";
    /** Yearly interval */
    DateHistogramAggregationInterval["YEAR"] = "YEAR";
    /** Monthly interval */
    DateHistogramAggregationInterval["MONTH"] = "MONTH";
    /** Weekly interval */
    DateHistogramAggregationInterval["WEEK"] = "WEEK";
    /** Daily interval */
    DateHistogramAggregationInterval["DAY"] = "DAY";
    /** Hourly interval */
    DateHistogramAggregationInterval["HOUR"] = "HOUR";
    /** Minute interval */
    DateHistogramAggregationInterval["MINUTE"] = "MINUTE";
    /** Second interval */
    DateHistogramAggregationInterval["SECOND"] = "SECOND";
})(DateHistogramAggregationInterval || (DateHistogramAggregationInterval = {}));
export var AggregationType;
(function (AggregationType) {
    AggregationType["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
    /** An aggregation where result buckets are dynamically built - one per unique value */
    AggregationType["VALUE"] = "VALUE";
    /** An aggregation, where user can define set of ranges - each representing a bucket */
    AggregationType["RANGE"] = "RANGE";
    /** A single-value metric aggregation - e.g. min, max, sum, avg */
    AggregationType["SCALAR"] = "SCALAR";
    /** An aggregation, where result buckets are dynamically built - one per time interval (hour, day, week, etc.) */
    AggregationType["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
    /** Multi-level aggregation, where each next aggregation is nested within previous one */
    AggregationType["NESTED"] = "NESTED";
})(AggregationType || (AggregationType = {}));
export var Mode;
(function (Mode) {
    /** Any of the search terms must be present */
    Mode["OR"] = "OR";
    /** All search terms must be present */
    Mode["AND"] = "AND";
})(Mode || (Mode = {}));
export var Status;
(function (Status) {
    Status["UNKNOWN"] = "UNKNOWN";
    /** Tiers are disabled */
    Status["DISABLED"] = "DISABLED";
    /** Tiers are enabled but not yet active */
    Status["DRAFT"] = "DRAFT";
    /** Tiers are active */
    Status["ACTIVE"] = "ACTIVE";
    /** Tiers are paused */
    Status["PAUSED"] = "PAUSED";
})(Status || (Status = {}));
export var ProviderName;
(function (ProviderName) {
    ProviderName["UNKNOWN"] = "UNKNOWN";
    ProviderName["SBS"] = "SBS";
    ProviderName["LICENSER"] = "LICENSER";
    ProviderName["BASS"] = "BASS";
    ProviderName["RESELLER"] = "RESELLER";
    ProviderName["RECURRING_INVOICES"] = "RECURRING_INVOICES";
})(ProviderName || (ProviderName = {}));
export var IntervalUnit;
(function (IntervalUnit) {
    /** unknown interval unit */
    IntervalUnit["UNKNOWN"] = "UNKNOWN";
    /** day */
    IntervalUnit["DAY"] = "DAY";
    /** week */
    IntervalUnit["WEEK"] = "WEEK";
    /** month */
    IntervalUnit["MONTH"] = "MONTH";
    /** year */
    IntervalUnit["YEAR"] = "YEAR";
})(IntervalUnit || (IntervalUnit = {}));
export var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["UNKNOWN"] = "UNKNOWN";
    SubscriptionStatus["AUTO_RENEW_ON"] = "AUTO_RENEW_ON";
    SubscriptionStatus["AUTO_RENEW_OFF"] = "AUTO_RENEW_OFF";
    SubscriptionStatus["MANUAL_RECURRING"] = "MANUAL_RECURRING";
    SubscriptionStatus["CANCELLED"] = "CANCELLED";
    SubscriptionStatus["TRANSFERRED"] = "TRANSFERRED";
})(SubscriptionStatus || (SubscriptionStatus = {}));
/** Reason for subscription reactivation */
export var ReactivationReasonEnum;
(function (ReactivationReasonEnum) {
    ReactivationReasonEnum["UNKNOWN"] = "UNKNOWN";
    /**
     * Subscription was reactivated due to billing status change from CANCELED to ACTIVE, for example if it was incorrectly
     * canceled because of suspicion of fraud
     */
    ReactivationReasonEnum["BILLING_STATUS_CHANGE"] = "BILLING_STATUS_CHANGE";
    /** Subscription was reactivated after a chargeback dispute */
    ReactivationReasonEnum["REACTIVATED_AFTER_CHARGEBACK"] = "REACTIVATED_AFTER_CHARGEBACK";
})(ReactivationReasonEnum || (ReactivationReasonEnum = {}));
export var Initiator;
(function (Initiator) {
    Initiator["UNKNOWN"] = "UNKNOWN";
    Initiator["USER_REQUESTED"] = "USER_REQUESTED";
    Initiator["APP_MANAGED"] = "APP_MANAGED";
    Initiator["PASSIVE"] = "PASSIVE";
})(Initiator || (Initiator = {}));
export var UnassignReason;
(function (UnassignReason) {
    UnassignReason["UNKNOWN"] = "UNKNOWN";
    UnassignReason["USER_REQUESTED"] = "USER_REQUESTED";
    UnassignReason["REPLACED_BY_ANOTHER_SUBSCRIPTION"] = "REPLACED_BY_ANOTHER_SUBSCRIPTION";
})(UnassignReason || (UnassignReason = {}));
/** Copied from SBS */
export var ContractSwitchType;
(function (ContractSwitchType) {
    ContractSwitchType["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    ContractSwitchType["ADDITIONAL_QUANTITY"] = "ADDITIONAL_QUANTITY";
    ContractSwitchType["CREDIT_UNUSED_PERIOD"] = "CREDIT_UNUSED_PERIOD";
    ContractSwitchType["REFUND_PRICE_DIFF"] = "REFUND_PRICE_DIFF";
    ContractSwitchType["ADJUST_PERIOD_END"] = "ADJUST_PERIOD_END";
    ContractSwitchType["DOWNGRADE_GRACE_PERIOD"] = "DOWNGRADE_GRACE_PERIOD";
    ContractSwitchType["FULL_AMOUNT_PERIOD"] = "FULL_AMOUNT_PERIOD";
    ContractSwitchType["END_OF_PERIOD"] = "END_OF_PERIOD";
    ContractSwitchType["PENDING_CHANGES"] = "PENDING_CHANGES";
    ContractSwitchType["DOWNGRADE_RENEWAL"] = "DOWNGRADE_RENEWAL";
})(ContractSwitchType || (ContractSwitchType = {}));
export var ContractSwitchReason;
(function (ContractSwitchReason) {
    ContractSwitchReason["EXTERNAL_PROVIDER_TRIGGER"] = "EXTERNAL_PROVIDER_TRIGGER";
    ContractSwitchReason["PRICE_INCREASE"] = "PRICE_INCREASE";
})(ContractSwitchReason || (ContractSwitchReason = {}));
/** Reason for Price Increase Trigger */
export var PriceIncreaseTrigger;
(function (PriceIncreaseTrigger) {
    PriceIncreaseTrigger["NEAR_RENEWAL"] = "NEAR_RENEWAL";
    PriceIncreaseTrigger["RECURRING_SUCCESS"] = "RECURRING_SUCCESS";
    PriceIncreaseTrigger["MANUAL"] = "MANUAL";
})(PriceIncreaseTrigger || (PriceIncreaseTrigger = {}));
/** Triggered when a subscription's product is adusted. */
export var ProductAdjustment;
(function (ProductAdjustment) {
    /** flag to show that the ContractSwitchedEvent is not applicable / needed */
    ProductAdjustment["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    /** flag to show that the ContractSwitchedEvent is a Downgrade */
    ProductAdjustment["DOWNGRADE"] = "DOWNGRADE";
})(ProductAdjustment || (ProductAdjustment = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _adjustPointsRequest = {};
const _adjustPointsResponse = {};
const _bulkAdjustPointsRequest = {};
const _bulkAdjustPointsResponse = {};
const _bulkUpsertAccountsRequest = {};
const _bulkUpsertAccountsResponse = {};
const _countAccountsRequest = {};
const _countAccountsResponse = {};
const _createAccountRequest = {};
const _createAccountResponse = {};
const _earnPointsRequest = {};
const _earnPointsResponse = {};
const _exportAccountsRequest = {};
const _exportAccountsResponse = {};
const _getAccountBySecondaryIdRequest = {};
const _getAccountBySecondaryIdResponse = {};
const _getAccountRequest = {};
const _getAccountResponse = {};
const _getCurrentMemberAccountRequest = {};
const _getCurrentMemberAccountResponse = {};
const _getProgramTotalsRequest = {};
const _getProgramTotalsResponse = {};
const _listAccountsRequest = {};
const _listAccountsResponse = {};
const _listUserAccountsRequest = {};
const _listUserAccountsResponse = {};
const _redeemDeterminedAmountOfPointsRequest = {};
const _redeemDeterminedAmountOfPointsResponse = {};
const _redeemPointsRequest = {};
const _redeemPointsResponse = {};
const _refundTransactionRequest = {};
const _refundTransactionResponse = {};
const _searchAccountsRequest = {};
const _searchAccountsResponse = {};
const _setMissingMemberIdRequest = {};
const _setMissingMemberIdResponse = {};
/**
 * Creates a loyalty account for one of a site's contacts.
 *
 * The `createAccount()` function returns a Promise that resolves to the new loyalty account when it is created.
 *
 * To create a new loyalty account, the customer must first be a site contact with a contact ID. See [contacts](wix-crm-backend/contacts) to learn more about a site's contacts. The site must also have an active loyalty program before loyalty accounts can be created. See the [`activateLoyaltyProgram()`](wix-loyalty-v2/programs/activateloyaltyprogram) function to activate a site's loyalty program.
 *
 * >**Note:** Only visitors with **Manage Loyalty** [permissions](https://support.wix.com/en/article/roles-permissions-accessing-roles-permissions) can create a loyalty account. <!--You can override the permissions with the `wix-auth` [`elevate()`](wix-auth/elevate) function.-->
 * @public
 * @requiredField contactId
 * @param contactId - Contact ID for a Wix site contact. See the [Contacts API](wix-crm-backend/contacts) to learn more.
 * @adminMethod
 */
export function createAccount(contactId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { contactId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createAccountRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createAccountResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['account']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([contactId]);
        const reqOpts = ambassadorWixLoyaltyV1Account.createAccount(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'contactId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Adds points to a loyalty account.
 *
 * The `earnPoints()` function returns a Promise that resolves to the updated loyalty account.
 *
 * Only a positive amount can be added using the `earnPoints()` function, to manually adjust an account's balance for a negative amount, use [`adjustPoints()`](wix-loyalty-v2/accounts/adjustpoints).
 *
 * The `earnPoints()` function allows customers to manually earn points to their loyalty accounts. To use this function you must include an `appId` and an `idempotencyKey`. Any string can be set as the `appId` or `idempotencyKey`. In contrast to when an account earns points through an action taken on your site, the `appId` automatically sets to the source app that generates the points. The transaction `type` is `"EARN"` for points earned this way.
 *
 * >**Note:** Only visitors with **Manage Loyalty** [permissions](https://support.wix.com/en/article/roles-permissions-accessing-roles-permissions) can earn loyalty points. <!--You can override the permissions with the `wix-auth` [`elevate()`](wix-auth/elevate) function.-->
 * @param accountId - Loyalty account ID.
 * @public
 * @requiredField accountId
 * @requiredField options.appId
 * @requiredField options.idempotencyKey
 * @param options - Earn points info.
 * @adminMethod
 */
export function earnPoints(accountId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            accountId: '$[0]',
            amount: '$[1].amount',
            description: '$[1].description',
            appId: '$[1].appId',
            idempotencyKey: '$[1].idempotencyKey',
            activityType: '$[1].activityType',
            orderId: '$[1].orderId',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _earnPointsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _earnPointsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['account']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([accountId, options]);
        const reqOpts = ambassadorWixLoyaltyV1Account.earnPoints(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'accountId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Adjusts the point balance of a loyalty account.
 *
 * The `adjustPoints()` function returns a Promise that resolves to the updated loyalty account.
 *
 * To adjust the points balance of an account you must include an `accountId`, a `revision` number, and the adjustment to make. You can also leave a description to explain the reason for the points adjustment.
 *
 * There are two ways to adjust the points of a loyalty account:
 * - `balance` allows you to set the total points balance to this new amount. The transaction `type` will return as `"ADJUST"`.
 * - `amount` allows you to alter the points balance by this amount. This amount can be a positive number to increase the points balance or a negative number to decrease the balance. The transaction type will return as `"GIVE"`.
 *
 * An account may not be adjusted to a negative balance. If you pass values in both the `balance` and the `amount` parameters then the `balance` adjustment takes effect and the `amount` adjustment is ignored.
 *
 * >**Note:** Only visitors with **Manage Loyalty** [permissions](https://support.wix.com/en/article/roles-permissions-accessing-roles-permissions) can manually adjust points in a loyalty account. <!--You can override the permissions with the `wix-auth` [`elevate()`](wix-auth/elevate) function.-->
 * @param accountId - Loyalty account ID.
 * @public
 * @requiredField accountId
 * @param options - Options to use when adjusting points.
 * @adminMethod
 */
export function adjustPoints(accountId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            accountId: '$[0]',
            description: '$[1].description',
            balance: '$[1].balance',
            amount: '$[1].amount',
            refund: '$[1].refund',
            revision: '$[1].revision',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _adjustPointsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _adjustPointsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['account']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([accountId, options]);
        const reqOpts = ambassadorWixLoyaltyV1Account.adjustPoints(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'accountId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Redeems points from a loyalty account, given the provided reward.
 * @param accountId - Loyalty account ID.
 * @param rewardId - Reward ID. See [Rewards API](https://dev.wix.com/api/rest/loyalty/rewards/rewards-object) for more details.
 * @internal
 * @documentationMaturity preview
 * @requiredField accountId
 * @requiredField rewardId
 * @adminMethod
 */
export function redeemPoints(accountId, rewardId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            accountId: '$[0]',
            rewardId: '$[1]',
            count: '$[2].count',
            revision: '$[2].revision',
            referenceEntityId: '$[2].referenceEntityId',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _redeemPointsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _redeemPointsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['account']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([accountId, rewardId, options]);
        const reqOpts = ambassadorWixLoyaltyV1Account.redeemPoints(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'accountId',
                'rewardId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Redeems given amount of points from a loyalty account, given the provided reward.
 * @param accountId - Loyalty account ID.
 * @param rewardId - Reward ID. See [Rewards API](https://dev.wix.com/api/rest/loyalty/rewards/rewards-object) for more details.
 * @internal
 * @documentationMaturity preview
 * @requiredField accountId
 * @requiredField rewardId
 * @adminMethod
 */
export function redeemDeterminedAmountOfPoints(accountId, rewardId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            accountId: '$[0]',
            rewardId: '$[1]',
            points: '$[2].points',
            revision: '$[2].revision',
            referenceEntityId: '$[2].referenceEntityId',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _redeemDeterminedAmountOfPointsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _redeemDeterminedAmountOfPointsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['account']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([accountId, rewardId, options]);
        const reqOpts = ambassadorWixLoyaltyV1Account.redeemDeterminedAmountOfPoints(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'accountId',
                'rewardId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Refunds a redeem transaction by deleting the loyalty coupon and adjusting the points balance.
 * @param transactionId - Transaction ID associated with the refund.
 * @internal
 * @documentationMaturity preview
 * @requiredField transactionId
 * @adminMethod
 */
export function refundTransaction(transactionId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { transactionId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _refundTransactionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _refundTransactionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([transactionId]);
        const reqOpts = ambassadorWixLoyaltyV1Account.refundTransaction(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'transactionId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves an account using the loyalty account ID.
 *
 * The `getAccount()` function returns a Promise that resolves to the specified loyalty account when it is retrieved.
 *
 * You can also get an account using a secondary ID, such as a contact ID or a member ID with the [`getAccountBySecondaryId()`](wix-loyalty-v2/accounts/getaccountbysecondaryid) function.
 *
 * >**Note:** Only visitors with **Manage Loyalty** [permissions](https://support.wix.com/en/article/roles-permissions-accessing-roles-permissions) can retrieve a loyalty account. <!--You can override the permissions with the `wix-auth` [`elevate()`](wix-auth/elevate) function.-->
 * @param _id - ID of the account to retrieve.
 * @public
 * @requiredField _id
 * @adminMethod
 * @returns Retrieved loyalty account.
 */
export function getAccount(_id) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { id: '$[0]' };
        const responseTransformation = '$.account';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getAccountRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getAccountResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['account']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id]);
        const reqOpts = ambassadorWixLoyaltyV1Account.getAccount(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Lists all accounts for Wix user.
 * @internal
 * @documentationMaturity preview
 * @adminMethod
 */
export function listUserAccounts(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { limit: '$[0].limit', offset: '$[0].offset' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listUserAccountsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listUserAccountsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#accounts.account']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixLoyaltyV1Account.listUserAccounts(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves the total amount of points earned, redeemed, and adjusted for the entire loyalty program.
 *
 * The `getProgramTotals()` function returns a Promise that resolves to the combined total points for all loyalty accounts in the program.
 *
 * The `balance` is the current total of points outstanding, while the `earned`, `adjusted`, and `redeemed` amounts are the all-time accumulated amounts. The totals include the amounts for all loyalty accounts.
 *
 * >**Note:** Only visitors with **Manage Loyalty** [permissions](https://support.wix.com/en/article/roles-permissions-accessing-roles-permissions) can retrieve the loyalty program totals. <!--You can override the permissions with the `wix-auth` [`elevate()`](wix-auth/elevate) function.-->
 * @public
 * @adminMethod
 */
export function getProgramTotals() {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {};
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[0];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getProgramTotalsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getProgramTotalsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([]);
        const reqOpts = ambassadorWixLoyaltyV1Account.getProgramTotals(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, []);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves the currently logged-in member's account.
 * @public */
export function getCurrentMemberAccount() {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {};
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[0];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getCurrentMemberAccountRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getCurrentMemberAccountResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['account']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([]);
        const reqOpts = ambassadorWixLoyaltyV1Account.getCurrentMemberAccount(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, []);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves the loyalty account of the specified site contact or member.
 *
 * The `getAccountBySecondaryId()` function returns a Promise that resolves to the specified loyalty account when it is retrieved.
 *
 * This function gets a loyalty account using either a customer's contact ID or member ID. You can also get an account using the loyalty account ID with the [`getAccount()`](wix-loyalty-v2/accounts/getaccount) function.
 *
 * >**Note:** Only visitors with **Manage Loyalty** [permissions](https://support.wix.com/en/article/roles-permissions-accessing-roles-permissions) can retrieve a loyalty account. <!--You can override the permissions with the `wix-auth` [`elevate()`](wix-auth/elevate) function.-->
 * @public
 * @param options - ID of the customer to retrieve loyalty account for.
 * @adminMethod
 */
export function getAccountBySecondaryId(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            contactId: '$[0].contactId',
            memberId: '$[0].memberId',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getAccountBySecondaryIdRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getAccountBySecondaryIdResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['account']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixLoyaltyV1Account.getAccountBySecondaryId(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of loyalty accounts, given the provided filters.
 *
 * The `listAccounts()` function returns a Promise that resolves to a list of loyalty accounts.
 *
 * You can retrieve selected loyalty accounts with an array of `contactIds` or retrieve a list of all of a site's loyalty accounts
 *     with an empty request parameter. Use the `cursorPaging` parameters to limit how many items load at a time.
 *
 * >**Note:** Only visitors with **Manage Loyalty** [permissions](https://support.wix.com/en/article/roles-permissions-accessing-roles-permissions) can retrieve loyalty accounts. <!--You can override the permissions with the `wix-auth` [`elevate()`](wix-auth/elevate) function.-->
 * @public
 * @param options - Options to use when retrieving a list of loyalty accounts.
 * @adminMethod
 */
export function listAccounts(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            contactIds: '$[0].contactIds',
            cursorPaging: '$[0].cursorPaging',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listAccountsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listAccountsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#accounts']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixLoyaltyV1Account.listAccounts(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of accounts, given the provided filters and search capabilities.
 * Search is executed on the account's name and email values.
 * @public
 * @adminMethod
 * @returns Accounts found through provided search capabilities, along with paging and aggregation data of the results.
 */
export function searchAccounts(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { search: '$[0].search' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _searchAccountsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _searchAccountsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#accounts']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixLoyaltyV1Account.searchAccounts(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Endpoint that proxies request with QueryV2 payload to SearchAccounts endpoint with CursorSearch in the payload
 * If search results are expected, they should be passed in the filter as the following fields:
 * "_search_mode": "OR" or "AND"
 * "_search_expression": Any string value
 * @internal
 * @documentationMaturity preview
 * @adminMethod
 */
export function exportAccounts(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { query: '$[0].query' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _exportAccountsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _exportAccountsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#accounts']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixLoyaltyV1Account.exportAccounts(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves the count of found accounts, given the provided filters and search capabilities.
 *
 * This endpoint can help find the total count of accounts when used alongside [Search Accounts](https://dev.wix.com/docs/rest/crm/loyalty-program/accounts/search-accounts).
 * @public
 * @adminMethod
 * @returns Count of accounts found for given search query
 */
export function countAccounts(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            filter: '$[0].filter',
            search: '$[0].search',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _countAccountsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _countAccountsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixLoyaltyV1Account.countAccounts(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates points balance of multiple accounts.
 * Depending on the BulkAdjustPointsRequest.type:
 * amount - provided amount of points is appended to the accounts balance
 * balance - accounts balance is set to the provided amount
 *
 * Returns id of the asyncInfra job that takes care of the points adjustment.
 * @public
 * @documentationMaturity preview
 * @adminMethod
 */
export function bulkAdjustPoints(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            search: '$[0].search',
            balance: '$[0].balance',
            amount: '$[0].amount',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkAdjustPointsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkAdjustPointsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixLoyaltyV1Account.bulkAdjustPoints(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Creates loyalty accounts for given contactIds with given points, or updates loyalty accounts if they already exist
 * @param accounts - List of contactIds + points to either insert as new loyalty accounts, or update if contacts already exist as loyalty accounts
 * @internal
 * @documentationMaturity preview
 * @requiredField accounts
 * @adminMethod
 */
export function bulkUpsertAccounts(accounts, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            accounts: '$[0]',
            returnAccounts: '$[1].returnAccounts',
            description: '$[1].description',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkUpsertAccountsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkUpsertAccountsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#result.account']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([accounts, options]);
        const reqOpts = ambassadorWixLoyaltyV1Account.bulkUpsertAccounts(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'accounts',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates account's member id if it is not already set but member exists
 * @param accountId - ID of the account to retrieve.
 * @internal
 * @documentationMaturity preview
 * @requiredField accountId
 * @adminMethod
 */
export function setMissingMemberId(accountId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { accountId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _setMissingMemberIdRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _setMissingMemberIdResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['account']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([accountId]);
        const reqOpts = ambassadorWixLoyaltyV1Account.setMissingMemberId(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'accountId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=loyalty-v1-account.universal.js.map